'use client';

import { App } from 'konsta/react';

export function KonstaRoot({ children }: { children: React.ReactNode }) {
  return (
    <App theme="ios" safeAreas>
      {children}
    </App>
  );
}
